<template>
    <section>
        <div class="row justify-content-center">
            <div class="col col-lg-10 px-5">
                <nav aria-label="breadcrumb">
                    <ul class="breadcrumb mt-5 mb-0 py-0">
                        <li class="breadcrumb-item h3 font-weight-bold active mb-0 text-uppercase" aria-current="page">
                            Forum
                        </li>
                    </ul>
                    <ul class="breadcrumb forum py-0">
                        <li class="breadcrumb-item font-weight-medium">
                            <router-link v-bind:to="{ name: 'index' }">
                                Home
                            </router-link>
                        </li>
                        <li class="breadcrumb-item font-weight-medium">
                            <router-link v-bind:to="{ name: 'forum/index' }">
                                Forum
                            </router-link>
                        </li>
                        <li class="breadcrumb-item font-weight-medium">
                            <router-link v-bind:to="{ name: 'forum/subject', params: {id: comment.thread.forumSubcategory.gradeSubject.gradeID} }">
                                {{ comment.thread.forumSubcategory.gradeSubject.grade.name }}
                            </router-link>
                        </li>
                        <li class="breadcrumb-item font-weight-medium">
                            <router-link v-bind:to="{ name: 'forum/category', params: {id: comment.thread.forumSubcategory.gradeSubjectID} }">
                                {{ comment.thread.forumSubcategory.gradeSubject.subject.name }}
                            </router-link>
                        </li>
                        <li class="breadcrumb-item font-weight-medium">
                            <router-link v-bind:to="{ name: 'forum/thread/index', params: {id: comment.thread.forumSubcategoryID} }">
                                {{ comment.thread.forumSubcategory.title }}
                            </router-link>
                        </li>
                        <li class="breadcrumb-item font-weight-medium">
                            <router-link v-bind:to="{ name: 'forum/thread/view', params: {id: comment.thread.id} }">
                                {{ comment.thread.title }}
                            </router-link>
                        </li>
                        <li class="breadcrumb-item font-weight-medium active" aria-current="page">
                            Edit Comment
                        </li>
                    </ul>
                </nav>
                <div class="row mb-3">
                    <div class="col">
                        <form v-on:submit.prevent="save">
                            <div class="card shadow-sm mb-3 border-0">
                                <div class="card-body">
                                    <div class="row mb-3">
                                        <div class="col-auto">
                                            <h3 class="font-weight-bold">Edit Comment</h3>
                                            <h4 class="font-weight-medium mb-0">
                                                {{ profile.name }}
                                                <small class="text-muted">{{ listRoles(profile) }}</small>
                                            </h4>
                                        </div>
                                    </div>
                                    <div class="row mb-3">
                                        <div class="col-12" v-if="comment.quoted">
                                            <blockquote class="blockquote rounded">
                                                <div v-html="comment.quoted.content"></div>
                                                <footer class="blockquote-footer font-weight-medium d-inline-block h4 text-dark">
                                                    {{ comment.quoted.user.name }}
                                                    <small class="text-muted">{{ listRoles(comment.quoted.user) }}</small>
                                                </footer>
                                            </blockquote>
                                        </div>
                                        <div class="col-12">
                                            <label class="font-weight-bold">Konten</label>
                                            <tinymce id="editor" v-model="form.content" v-bind:other_options="tinyMCEOptions"></tinymce>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-auto ml-auto">
                                            <button type="submit" class="btn btn-danger btn-sm px-5">
                                                Post
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import tinymce from 'vue-tinymce-editor';
    import { tinyMCEOptions, employeeRoles, additionalRoles } from '@/params.js';
    import { mapState } from 'vuex';

    export default {
        name: "ForumThreadCommentEdit",
        computed: mapState([
            'profile'
        ]),
        components: {
            tinymce
        },
        data() {
            return {
                form: {
                    content: ''
                },
                comment: {thread: {forumSubcategory: {gradeSubject: {grade: {}, subject: {}}}}},
                roles: [],
                tinyMCEOptions: tinyMCEOptions
            };
        },
        methods: {
            save() {
                this.axios.post(process.env.API_URL + '/comment/update/' + this.comment.id, this.form).then(response => {
                    if (response.data.status) {
                        this.$toastr('success', response.data.message, 'Success');
                        this.$router.push({name: 'forum/thread/view', params: {id: this.comment.thread.id}});
                    } else {
                        this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                    }
                });
            },
            listRelations(relations) {
                return typeof relations !== typeof undefined ? relations.map(object => object.name).join(', ') : '';
            },
            listRoles(user) {
                var roles = [];
                for (var i in additionalRoles) {
                    if (user['is' + additionalRoles[i].id]) {
                        roles.push(additionalRoles[i].id);
                    }
                }
                if (user.isEmployee) {
                    for (var i in employeeRoles) {
                        if (user.employee['is' + employeeRoles[i].id]) {
                            roles.push(employeeRoles[i].id);
                        }
                    }
                }
                return this.listRelations(this.roles.filter(object => roles.includes(object.id)));
            },
            roleElligible() {
                return this.profile.isAdmin || (this.comment.userID === this.profile.id && this.$moment().utcOffset(0).isBefore(this.$moment(this.comment.createdAt, 'YYYY-MM-DD HH:mm:ss').utcOffset(0).add(process.env.FORUM_CHANGE_MINUTES, 'minutes')));
            }
        },
        created() {
            this.roles = employeeRoles.concat(additionalRoles);
            this.axios.get(process.env.API_URL + '/comment/' + this.$route.params.id).then(response => {
                this.comment = response.data.data;
                if (!this.roleElligible()) {
                    this.$router.replace({name: 'error', params: {code: 403, message: 'User Not Authorize'}});
                }

                this.form = this.comment;

                document.title = 'Forum - Edit Comment ' + this.comment.thread.title + ' | ' + process.env.APP_NAME;
            });

        }
    };
</script>


// WEBPACK FOOTER //
// src/components/forum/thread/comment/Edit.vue